export enum AgentState {
  LOADING = "loading",
  ERROR = "error",
  IDLE = "idle",
  TYPING = "typing",
  SPEAKING = "speaking",
  LISTENING = "listening",
}
